'use-strict'
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'babel-polyfill'

import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios'
import BrowserCheck from './scripts/BrowserCheck'
import ThemeLinksParse from './scripts/ThemeLinks'

import AppContainer from './containers/AppContainer'
import {CreateCategories} from './components/Categories'
import SiteLocation from './scripts/SiteLocation'
import CompanyID from './scripts/CompanyID'
import { SetThemeVars } from './scripts/ThemeVars'

import LogThis from './scripts/LogThis'

require('./styles.css')

var Set = require('es6-set/polyfill')

const App = document.getElementById('app')

const LOC = SiteLocation()

const CompID = CompanyID(LOC[1])

const API_URL = LOC[0] + '//' + LOC[1] + '/index.php/json/lesson-all?companyID=' + CompID[0]
const THEME_URL = LOC[0] + '//' + LOC[1] + '/index.php/json/preview-themes/' + CompID[1]
const LOGGED_URL = LOC[0] + '//' + LOC[1] + '/index.php/api/logged-in'

console.log(THEME_URL)

const DeviceInfo = BrowserCheck()

class FetchData extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      fetched: false,
      json: [],
      categories: [],
      location: LOC[1],
      themeLinks: [],
      browserInfo: [
        DeviceInfo.supported, DeviceInfo.browserName, DeviceInfo.browserVersion, DeviceInfo.deviceType, DeviceInfo.deviceOS, DeviceInfo.osVersion
      ],
      windowDimensions: [ window.innerWidth, window.innerHeight ],
      mobileView: false, //phone, tablet
      loggedIn: false,
      loggedInInfo: {
        userName: '',
        userId: '',
        userEmail: '',
        userGroup: '',
        salesContact: ''
      }
    }

  }

  setData = (a) => {
    this.setState({fetched: true, json: a})
    CreateCategories(this.state.json, this.createCategories)
  }

  setTheme = (a) => {
    const ThemeLinks = ThemeLinksParse(a)
    this.setState({themeLinks: ThemeLinks})
  }

  setLoggedIn = (a) => {
    if ( a.userName !== '' ) {
      this.setState({
        loggedIn: true,
        loggedInInfo: {
          userName: a.userName,
          userId: a.userId,
          userFirstName: a.firstName,
          userLastName: a.lastName,
          userEmail: a.userEmail,
          userGroup: a.userGroup,
          salesContact: a.salesContact
        }
      }, () => {
        LogThis(this.state.loggedInInfo, 'enter', null)
      })
    } else {
      this.setState({
        loggedIn: false,
        loggedInInfo: {
          userName: '',
          userId: '',
          userFirstName: '',
          userLastName: '',
          userEmail: '',
          userGroup: '',
          salesContact: ''
        }
      })
    }
  }

  getLoggedIn = () => {
    axios.get(LOGGED_URL).then(res => {
      this.setLoggedIn(res.data)
    }).catch(function(error) {
      console.log(error)
    })
  }


  createCategories = (a) => {
    this.setState({categories: a})
  }

  setWindowDimensions = (w,h) => {

    this.setState({windowDimensions: [w, h]})

    if ( this.state.browserInfo[3] === 'phone' ) {
      this.setState({mobileView: true})
    } else {
      if ( this.state.windowDimensions[0] < 900 ) {
          this.setState({ mobileView: true })
      } else {
        this.setState({ mobileView: false })
      }
    }
  }

  updateDimensions = () => {
    this.setWindowDimensions(window.innerWidth, window.innerHeight)
  }

  componentDidMount() {
    this.setWindowDimensions(window.innerWidth, window.innerHeight)
    window.addEventListener("resize", this.updateDimensions);

    window.onbeforeunload = function(e) {
      if ( this.state.loggedIn === true ) {
        LogThis(this.state.loggedInInfo, 'exit', null)
      }
    }

    axios.get(API_URL).then(res => {
      const ParsedData = []
      const CourseIDs = []

      const MyData = res.data

      for ( let course in MyData ) {
        if ( !CourseIDs.includes(MyData[course].entry_id) ) {
          CourseIDs.push(MyData[course].entry_id)
          ParsedData.push(MyData[course])
        }
      }

      this.setData(ParsedData)

    }).catch(function(error) {
      console.log(error)
    })
    axios.get(THEME_URL).then(res => {
      this.setTheme(res.data)
    }).catch(function(error) {
      console.log(error)
    })
    this.getLoggedIn()
  }


  render() {
    const ThemeStyles =  SetThemeVars(CompID[0])

    if ( this.state.fetched === true ) {
      return (
        <AppContainer
          localURL={LOC[1]}
          companyID={CompID[0]}
          jsonData={this.state.json}
          themeLinks={this.state.themeLinks}
          categories={this.state.categories}
          browserInfo={this.state.browserInfo}
          loggedIn={this.state.loggedIn}
          loggedInInfo={this.state.loggedInInfo}
          mobileView={this.state.mobileView}
          winDimensions={this.state.windowDimensions}
          themeStyles={ThemeStyles} />
      )
    } else {
      return (
        <div className="spinner">
          <div className="rect1"></div>
          <div className="rect2"></div>
          <div className="rect3"></div>
          <div className="rect4"></div>
          <div className="rect5"></div>
        </div>
      )
    }


  }

}

ReactDOM.render(
  <FetchData/>, App)
//registerServiceWorker();
